import component from "./AgreementCheckBoxField";
export default component;
